import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var HeartBreak = function HeartBreak(_ref) {
  var className = _ref.className,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? '#181B32' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size,
    ignoreColor = _ref.ignoreColor;
  return /*#__PURE__*/_jsx("svg", {
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size * 1.240310078,
    height: size,
    viewBox: "0 0 160.49 129.07",
    children: /*#__PURE__*/_jsx("g", {
      id: "Layer_2",
      "data-name": "Layer 2",
      children: /*#__PURE__*/_jsxs("g", {
        id: "Layer_1-2",
        "data-name": "Layer 1",
        children: [/*#__PURE__*/_jsx("path", {
          fill: !ignoreColor ? color : undefined,
          d: "M69.38,118,86.56,78.44a2.72,2.72,0,0,0-2.5-3.8H57.26a8.26,8.26,0,0,1-1.56-.16A7.6,7.6,0,0,1,54.19,74h0c-.13-.06-.24-.15-.37-.21a7.65,7.65,0,0,1-.93-.52,40.16,40.16,0,0,1-1.15-1c-.18-.19-.33-.4-.5-.6s-.31-.37-.45-.57-.23-.43-.35-.65-.25-.45-.35-.69-.15-.49-.22-.73-.16-.46-.21-.7a8.34,8.34,0,0,1-.11-1.11c0-.13,0-.25,0-.39s0,0,0,0a7.32,7.32,0,0,1,.12-1.23c0-.11,0-.22,0-.33s.09-.27.13-.4a6.88,6.88,0,0,1,.34-1.09,0,0,0,0,0,0,0L71.45,14.64A1.52,1.52,0,0,0,71.13,13l-.25-.26C54.69-3.48,27.71-4,11.62,12.3s-15.06,41.4.17,58.33c11,12.24,37,34.5,53.56,48.34A2.58,2.58,0,0,0,69.38,118Z"
        }), /*#__PURE__*/_jsx("path", {
          fill: !ignoreColor ? color : undefined,
          d: "M81.55,129.05c-.34.79,50.39-39.79,67.15-58.42,15.28-17,16.16-42.35,0-58.51a41.37,41.37,0,0,0-58.51,0l-.21.21a7.28,7.28,0,0,0-1.57,2.31L72.5,51.3a5.55,5.55,0,0,0,5.09,7.77H100.1a7.46,7.46,0,0,1,1.24.13c.1,0,.21,0,.31,0l.39.12a8.42,8.42,0,0,1,1.11.35h0a3.14,3.14,0,0,1,.31.18,6.94,6.94,0,0,1,1,.56,4.7,4.7,0,0,1,.55.45,4.9,4.9,0,0,1,.6.51c.18.19.33.39.49.59s.32.38.45.59a5.71,5.71,0,0,1,.35.64,5,5,0,0,1,.35.69,6.54,6.54,0,0,1,.24.75c.06.23.15.45.2.69a8.62,8.62,0,0,1,.11,1.15c0,.12,0,.22,0,.34a0,0,0,0,1,0,0,7.45,7.45,0,0,1-.12,1.25c0,.11,0,.21,0,.31s-.08.24-.11.36a8.88,8.88,0,0,1-.36,1.14"
        }), /*#__PURE__*/_jsx("path", {
          fill: !ignoreColor ? color : undefined,
          d: "M107.22,69.93v0l-25.66,59.1"
        })]
      })
    })
  });
};
export default HeartBreak;